var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShift = function SvgShift(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 15.9166C11.4363 15.9166 12.814 15.3459 13.8298 14.3301C14.8457 13.3143 15.4163 11.9365 15.4163 10.4999C15.4163 9.06333 14.8457 7.68558 13.8298 6.66976C12.814 5.65393 11.4363 5.08325 9.99967 5.08325C8.56308 5.08325 7.18533 5.65393 6.16951 6.66976C5.15369 7.68558 4.58301 9.06333 4.58301 10.4999C4.58301 11.9365 5.15369 13.3143 6.16951 14.3301C7.18533 15.3459 8.56308 15.9166 9.99967 15.9166Z",
    stroke: "#2E3293",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9503 16.4501L15.842 16.3417M15.842 4.65841L15.9503 4.55008M4.05033 16.4501L4.15866 16.3417M10.0003 2.23341V2.16675M10.0003 18.8334V18.7667M1.73366 10.5001H1.66699M18.3337 10.5001H18.267M4.15866 4.65841L4.05033 4.55008",
    stroke: "#2E3293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shift.92d55800.svg";
export { ForwardRef as ReactComponent };